import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import CompactLayout from 'src/layouts/compact';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const NoDataEntityPage = lazy(() => import('src/pages/error/noDataEntity/index'));
const PermissionDeniedPage = lazy(() => import('src/pages/error/permissionDenied/index'));

// ----------------------------------------------------------------------

export const errorRoutes = [
  {
    element: (
      <CompactLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactLayout>
    ),
    children: [
      {
        path: 'error',
        children: [
          {
            path: 'no-data-entity',
            element: <NoDataEntityPage />,
          },
          {
            path: 'permission-denied',
            element: <PermissionDeniedPage />,
          },
        ],
      },
    ],
  },
];
